{
  "LABEL_MGMT": {
    "HEADER": "Категории",
    "HEADER_BTN_TXT": "Добавить категорию",
    "LOADING": "Загрузка категорий",
    "DESCRIPTION": "Категории помогают вам классифицировать и приоритизировать разговоры и лидеров. Вы можете назначить категорию для разговора или контакта с помощью боковой панели.",
    "LEARN_MORE": "Узнать больше о категориях",
    "SEARCH_404": "Нет категорий, соответствующих запросу",
    "LIST": {
      "404": "У вас нет категорий.",
      "TITLE": "Управлять категориями",
      "DESC": "Категории позволяют вам группировать диалоги.",
      "TABLE_HEADER": {
        "NAME": "Имя",
        "DESCRIPTION": "Описание",
        "COLOR": "Цвет"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Название категории",
        "PLACEHOLDER": "Название категории",
        "REQUIRED_ERROR": "Требуется название метки",
        "MINIMUM_LENGTH_ERROR": "Минимальная длина 2 обязательна",
        "VALID_ERROR": "Разрешены только алфавиты, числа, дефисы и подчеркивание"
      },
      "DESCRIPTION": {
        "LABEL": "Описание",
        "PLACEHOLDER": "Описание категории"
      },
      "COLOR": {
        "LABEL": "Цвет"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "Показывать категорию на боковой панели"
      },
      "EDIT": "Редактировать",
      "CREATE": "Создать",
      "DELETE": "Удалить",
      "CANCEL": "Отменить"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Добавить метку в разговор",
        "MULTIPLE_SUGGESTION": "Выбрать метку",
        "DESELECT": "Отменить выбор метки",
        "DISMISS": "Отменить предложение"
      },
      "POWERED_BY": "AI",
      "DISMISS": "Отклонить",
      "ADD_SELECTED_LABELS": "Добавить выбранные метки",
      "ADD_SELECTED_LABEL": "Добавить метку",
      "ADD_ALL_LABELS": "Добавить все метки",
      "SUGGESTED_LABELS": "Предложенные категории"
    },
    "ADD": {
      "TITLE": "Добавить категорию",
      "DESC": "Категории позволяют вам группировать диалоги.",
      "API": {
        "SUCCESS_MESSAGE": "Категория добавлена",
        "ERROR_MESSAGE": "Произошла ошибка, попробуйте еще раз"
      }
    },
    "EDIT": {
      "TITLE": "Редактировать категорию",
      "API": {
        "SUCCESS_MESSAGE": "Категория сохранена",
        "ERROR_MESSAGE": "Произошла ошибка, попробуйте еще раз"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Удалить",
      "API": {
        "SUCCESS_MESSAGE": "Категория удалена",
        "ERROR_MESSAGE": "Произошла ошибка, попробуйте еще раз",
        "IN_USE_ERROR": "Эту категорию нельзя удалить, так как она используется в {usages}. Сначала удалите её из этих записей.",
        "IN_USE_FILTERS": "фильтры: {names}",
        "IN_USE_AUTOMATIONS": "правила автоматизации: {names}",
        "IN_USE_MACROS": "макросы: {names}"
      },
      "CONFIRM": {
        "TITLE": "Подтвердите удаление",
        "MESSAGE": "Вы точно хотите удалить ",
        "YES": "Да, удалить ",
        "NO": "Нет, не удалять "
      }
    }
  }
}
